import { m3RookieD, m3RookieR } from "../../../../data/clueData";

export const RookieStageClearData = {
  missionNumber: "3",
  missionTitle: "Rookie",
  missionDebrief: `"The tech park is an interesting lead. ByteFox’s trail might be clearer with more analysis. Try Intermediate or Advanced to dive deeper."`,
  description:
    "Complete all missions to this level and receive a special invite at the project debriefing.",
  nextLevel: "/digitalBreadcrumbs",
  selectedLevel: "intermediate",
};

export const RookieStageFailData = {
  missionNumber: "3",
  missionTitle: "Rookie",
  levelName: "Rookie",
  description: "Every challenge is an opportunity to learn and grow.",
  nextLevel: "/rookie",
};

export const clueData = {
  message: null,
  clueItems: [
    {
      icon: m3RookieR,
      description: null,
    },
    {
      icon: m3RookieD,
      description: null,
    },
  ],
};
